import { render, staticRenderFns } from "./rate-field.vue?vue&type=template&id=f3c5e6b2&scoped=true&"
import script from "./rate-field.vue?vue&type=script&lang=ts&"
export * from "./rate-field.vue?vue&type=script&lang=ts&"
import style0 from "./rate-field.vue?vue&type=style&index=0&id=f3c5e6b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c5e6b2",
  null
  
)

export default component.exports